import { ApplicationInsights } from "@microsoft/applicationinsights-web"
import { ContextProviders } from "common/ContextProviders"
import { trackPage } from "common/analytics"
import Layout from "layout/Layout"
import { DefaultSeo } from "next-seo"
import { AppProps } from "next/app"
import { Router, useRouter } from "next/router"
import { useEffect } from "react"
import styled from "styled-components"
import "swiper/css/bundle"
import ThemeProviders from "theme/ThemeProviders"
import colors from "theme/colors"

if (process.env.NODE_ENV !== "development" && typeof window === "undefined")
  import("applicationinsights")

const ENV = process.env.ENV
const ORIGIN = process.env.ORIGIN
if (!ORIGIN) {
  throw new Error("Please provide the ORIGIN environment variable.")
}

const AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY =
  process.env.AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY

const StyledEnvironmentName = styled.pre`
  background-color: ${colors.cherryRed};
  color: ${colors.white};
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999999999999;
  margin: 0;
  opacity: 0.8;
  pointer-events: none;
`

Router.events.on("routeChangeComplete", () => {
  trackPage()
})

const MyApp = ({ Component, pageProps }: AppProps) => {
  useEffect(() => {
    // Remove the server-side injected CSS
    const jssStyles = document.querySelector("#jss-server-side")
    jssStyles?.parentElement?.removeChild(jssStyles)

    // Initialize Azure Application Insights
    if (
      window &&
      AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY &&
      !window.appInsights
    ) {
      window.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY,
        },
      })
      window.appInsights.loadAppInsights()
      window.appInsights.trackPageView()
    }
  }, [])

  const { asPath } = useRouter()
  const url = (ORIGIN + asPath).split(/[?#]/)[0] // remove query string & hash
  return (
    <>
      <DefaultSeo
        titleTemplate="%s - McDonald’s Gift Cards"
        canonical={url}
        openGraph={{
          site_name: "McDonald’s Gift Cards",
          locale: "he_IL",
          type: "website",
          url,
        }}
      />

      <ThemeProviders>
        <ContextProviders>
          <Layout>
            <Component {...pageProps} />
          </Layout>
        </ContextProviders>
      </ThemeProviders>
      {ENV && ENV !== "production" && (
        <StyledEnvironmentName>{ENV}</StyledEnvironmentName>
      )}
    </>
  )
}

export default MyApp
